var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c.3 3.9 1.8 5.4 5.7 5.7 .5.04.5.56 0 .6C13.8 8.6 12.3 10.1 12 14c-.04.5-.56.5-.6 0C11.1 10.1 9.6 8.6 5.7 8.3c-.5-.04-.5-.56 0-.6C9.6 7.4 11.1 5.9 11.4 2c.04-.5.56-.5.6 0Z",
    fill: "url(#aiSparkleGrad)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13c.15 1.7.85 2.4 2.5 2.5 .3.02.3.3 0 .32-1.65.1-2.35.8-2.5 2.5-.02.3-.3.3-.32 0-.15-1.7-.85-2.4-2.5-2.5-.3-.02-.3-.3 0-.32 1.65-.1 2.35-.8 2.5-2.5.02-.3.3-.3.32 0Z",
    fill: "url(#aiSparkleGrad)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aiSparkleGrad",
    x1: 4,
    y1: 2,
    x2: 22,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B8DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9B5BEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C3B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSparkle);
export default __webpack_public_path__ + "static/media/ai-sparkle.3506198d351f55804666ed9d269ef2ae.svg";
export { ForwardRef as ReactComponent };